class TrenwickDeferredImage extends HTMLElement {
  connectedCallback() {
    this.observer = new IntersectionObserver((entries) => {
      if (!entries.some((entry) => entry.isIntersecting)) return;
      const image = this.querySelector('img[data-src]');
      if (image) {
        if (image.dataset.srcset) image.srcset = image.dataset.srcset;
        image.src = image.dataset.src;
        delete image.dataset.src;
        delete image.dataset.srcset;
      }
      this.observer.disconnect();
    }, { rootMargin: '200px' });
    this.style.display = 'block';
    this.observer.observe(this);
  }
  disconnectedCallback() { this.observer?.disconnect(); }
}
if (!customElements.get('trenwick-deferred-image')) customElements.define('trenwick-deferred-image', TrenwickDeferredImage);
